import { toSeoUrl } from '.';
import { IFlat } from '../model/flat.model';

export const getFlatSlug = (flat: IFlat): string => {
  return (
    toSeoUrl(`${flat.city}-${flat.address}`.substring(0, 120)) +
    '-' +
    flat.id.substring(flat.id.length - 5)
  );
};

export const getFlatDescription = (
  flat: IFlat,
  activeLocale: string
): string => {
  if (activeLocale === 'en') {
    return flat.description_EN;
  }
  return flat.description_ES;
};
